(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4965],{

/***/ 39664:
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
	 true ? factory(exports) :
	0;
}(this, (function (exports) { 'use strict';

	/*!
	 * ScrollToPlugin 3.11.5
	 * https://greensock.com
	 *
	 * @license Copyright 2008-2023, GreenSock. All rights reserved.
	 * Subject to the terms at https://greensock.com/standard-license or for
	 * Club GreenSock members, the agreement issued with that membership.
	 * @author: Jack Doyle, jack@greensock.com
	*/
	var gsap,
	    _coreInitted,
	    _window,
	    _docEl,
	    _body,
	    _toArray,
	    _config,
	    ScrollTrigger,
	    _windowExists = function _windowExists() {
	  return typeof window !== "undefined";
	},
	    _getGSAP = function _getGSAP() {
	  return gsap || _windowExists() && (gsap = window.gsap) && gsap.registerPlugin && gsap;
	},
	    _isString = function _isString(value) {
	  return typeof value === "string";
	},
	    _isFunction = function _isFunction(value) {
	  return typeof value === "function";
	},
	    _max = function _max(element, axis) {
	  var dim = axis === "x" ? "Width" : "Height",
	      scroll = "scroll" + dim,
	      client = "client" + dim;
	  return element === _window || element === _docEl || element === _body ? Math.max(_docEl[scroll], _body[scroll]) - (_window["inner" + dim] || _docEl[client] || _body[client]) : element[scroll] - element["offset" + dim];
	},
	    _buildGetter = function _buildGetter(e, axis) {
	  var p = "scroll" + (axis === "x" ? "Left" : "Top");

	  if (e === _window) {
	    if (e.pageXOffset != null) {
	      p = "page" + axis.toUpperCase() + "Offset";
	    } else {
	      e = _docEl[p] != null ? _docEl : _body;
	    }
	  }

	  return function () {
	    return e[p];
	  };
	},
	    _clean = function _clean(value, index, target, targets) {
	  _isFunction(value) && (value = value(index, target, targets));

	  if (typeof value !== "object") {
	    return _isString(value) && value !== "max" && value.charAt(1) !== "=" ? {
	      x: value,
	      y: value
	    } : {
	      y: value
	    };
	  } else if (value.nodeType) {
	    return {
	      y: value,
	      x: value
	    };
	  } else {
	    var result = {},
	        p;

	    for (p in value) {
	      result[p] = p !== "onAutoKill" && _isFunction(value[p]) ? value[p](index, target, targets) : value[p];
	    }

	    return result;
	  }
	},
	    _getOffset = function _getOffset(element, container) {
	  element = _toArray(element)[0];

	  if (!element || !element.getBoundingClientRect) {
	    return console.warn("scrollTo target doesn't exist. Using 0") || {
	      x: 0,
	      y: 0
	    };
	  }

	  var rect = element.getBoundingClientRect(),
	      isRoot = !container || container === _window || container === _body,
	      cRect = isRoot ? {
	    top: _docEl.clientTop - (_window.pageYOffset || _docEl.scrollTop || _body.scrollTop || 0),
	    left: _docEl.clientLeft - (_window.pageXOffset || _docEl.scrollLeft || _body.scrollLeft || 0)
	  } : container.getBoundingClientRect(),
	      offsets = {
	    x: rect.left - cRect.left,
	    y: rect.top - cRect.top
	  };

	  if (!isRoot && container) {
	    offsets.x += _buildGetter(container, "x")();
	    offsets.y += _buildGetter(container, "y")();
	  }

	  return offsets;
	},
	    _parseVal = function _parseVal(value, target, axis, currentVal, offset) {
	  return !isNaN(value) && typeof value !== "object" ? parseFloat(value) - offset : _isString(value) && value.charAt(1) === "=" ? parseFloat(value.substr(2)) * (value.charAt(0) === "-" ? -1 : 1) + currentVal - offset : value === "max" ? _max(target, axis) - offset : Math.min(_max(target, axis), _getOffset(value, target)[axis] - offset);
	},
	    _initCore = function _initCore() {
	  gsap = _getGSAP();

	  if (_windowExists() && gsap && typeof document !== "undefined" && document.body) {
	    _window = window;
	    _body = document.body;
	    _docEl = document.documentElement;
	    _toArray = gsap.utils.toArray;
	    gsap.config({
	      autoKillThreshold: 7
	    });
	    _config = gsap.config();
	    _coreInitted = 1;
	  }
	};

	var ScrollToPlugin = {
	  version: "3.11.5",
	  name: "scrollTo",
	  rawVars: 1,
	  register: function register(core) {
	    gsap = core;

	    _initCore();
	  },
	  init: function init(target, value, tween, index, targets) {
	    _coreInitted || _initCore();
	    var data = this,
	        snapType = gsap.getProperty(target, "scrollSnapType");
	    data.isWin = target === _window;
	    data.target = target;
	    data.tween = tween;
	    value = _clean(value, index, target, targets);
	    data.vars = value;
	    data.autoKill = !!value.autoKill;
	    data.getX = _buildGetter(target, "x");
	    data.getY = _buildGetter(target, "y");
	    data.x = data.xPrev = data.getX();
	    data.y = data.yPrev = data.getY();
	    ScrollTrigger || (ScrollTrigger = gsap.core.globals().ScrollTrigger);
	    gsap.getProperty(target, "scrollBehavior") === "smooth" && gsap.set(target, {
	      scrollBehavior: "auto"
	    });

	    if (snapType && snapType !== "none") {
	      data.snap = 1;
	      data.snapInline = target.style.scrollSnapType;
	      target.style.scrollSnapType = "none";
	    }

	    if (value.x != null) {
	      data.add(data, "x", data.x, _parseVal(value.x, target, "x", data.x, value.offsetX || 0), index, targets);

	      data._props.push("scrollTo_x");
	    } else {
	      data.skipX = 1;
	    }

	    if (value.y != null) {
	      data.add(data, "y", data.y, _parseVal(value.y, target, "y", data.y, value.offsetY || 0), index, targets);

	      data._props.push("scrollTo_y");
	    } else {
	      data.skipY = 1;
	    }
	  },
	  render: function render(ratio, data) {
	    var pt = data._pt,
	        target = data.target,
	        tween = data.tween,
	        autoKill = data.autoKill,
	        xPrev = data.xPrev,
	        yPrev = data.yPrev,
	        isWin = data.isWin,
	        snap = data.snap,
	        snapInline = data.snapInline,
	        x,
	        y,
	        yDif,
	        xDif,
	        threshold;

	    while (pt) {
	      pt.r(ratio, pt.d);
	      pt = pt._next;
	    }

	    x = isWin || !data.skipX ? data.getX() : xPrev;
	    y = isWin || !data.skipY ? data.getY() : yPrev;
	    yDif = y - yPrev;
	    xDif = x - xPrev;
	    threshold = _config.autoKillThreshold;

	    if (data.x < 0) {
	      data.x = 0;
	    }

	    if (data.y < 0) {
	      data.y = 0;
	    }

	    if (autoKill) {
	      if (!data.skipX && (xDif > threshold || xDif < -threshold) && x < _max(target, "x")) {
	        data.skipX = 1;
	      }

	      if (!data.skipY && (yDif > threshold || yDif < -threshold) && y < _max(target, "y")) {
	        data.skipY = 1;
	      }

	      if (data.skipX && data.skipY) {
	        tween.kill();
	        data.vars.onAutoKill && data.vars.onAutoKill.apply(tween, data.vars.onAutoKillParams || []);
	      }
	    }

	    if (isWin) {
	      _window.scrollTo(!data.skipX ? data.x : x, !data.skipY ? data.y : y);
	    } else {
	      data.skipY || (target.scrollTop = data.y);
	      data.skipX || (target.scrollLeft = data.x);
	    }

	    if (snap && (ratio === 1 || ratio === 0)) {
	      y = target.scrollTop;
	      x = target.scrollLeft;
	      snapInline ? target.style.scrollSnapType = snapInline : target.style.removeProperty("scroll-snap-type");
	      target.scrollTop = y + 1;
	      target.scrollLeft = x + 1;
	      target.scrollTop = y;
	      target.scrollLeft = x;
	    }

	    data.xPrev = data.x;
	    data.yPrev = data.y;
	    ScrollTrigger && ScrollTrigger.update();
	  },
	  kill: function kill(property) {
	    var both = property === "scrollTo";

	    if (both || property === "scrollTo_x") {
	      this.skipX = 1;
	    }

	    if (both || property === "scrollTo_y") {
	      this.skipY = 1;
	    }
	  }
	};
	ScrollToPlugin.max = _max;
	ScrollToPlugin.getOffset = _getOffset;
	ScrollToPlugin.buildGetter = _buildGetter;
	_getGSAP() && gsap.registerPlugin(ScrollToPlugin);

	exports.ScrollToPlugin = ScrollToPlugin;
	exports.default = ScrollToPlugin;

	Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ 44937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ PageAnimation; }
/* harmony export */ });
var PageAnimation = {
  init: {
    // height: "100%",
    // top: 0,
    // bottom: 'auto',
    opacity: 1,
    zIndex: 99999,
    transition: {
      duration: .2,
      ease: 'easeInOut'
    }
  },
  anim: {
    // height: "0%",
    // bottom: 0,
    // top: 'auto',
    opacity: 1,
    zIndex: -1,
    transition: {
      delay: .6,
      duration: 1,
      ease: 'easeInOut',
      zIndex: {
        delay: 1.5
      }
    }
  },
  exit: {
    opacity: 0,
    zIndex: 99999,
    transition: {
      duration: .2,
      delay: 0.4 // delayChildren: 0.3,
      // staggerChildren: .06

    }
  }
};

/***/ }),

/***/ 13810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var src = _ref.src,
      visible = _ref.visible,
      speed = _ref.speed,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  // const smoother = useContext(SmootherContext);
  //
  // useEffect(() => {
  //     smoother.effects("img", {speed: "auto"})
  // }, [])
  var DefaultBanner = '/images/static/blurbg.svg';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image  ",
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
      alt: alt || 'Shanta Securities Limited',
      src: src || DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ImgP__StyledImg",
  componentId: "sc-3jyf6w-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";overflow:hidden;img{width:100%;height:120svh;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;will-change:transform;@media(max-width:767px){height:100% !important;}}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 87820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97346);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36981);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30653);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(68312);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87536);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22920);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25317);
/* harmony import */ var _ImgP__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13810);
/* harmony import */ var _pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92495);
/* harmony import */ var _pages_api_redux_home__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var Subscribe = function Subscribe(_ref) {
  var _section_image$list, _section_image$list$, _section_image$list2, _section_image$list2$, _formState$errors, _formState$errors$ema;

  var img = _ref.img,
      text = _ref.text,
      data = _ref.data,
      no = _ref.no;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  var section_image = data === null || data === void 0 ? void 0 : data.images;
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
  var responseData = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function (state) {
    return state.homeReducer;
  });

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .useForm */ .cI)({
    mode: 'all'
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      formState = _useForm.formState,
      reset = _useForm.reset; //--- form submit


  var success = function success(msg) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.success */ .Am.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var error = function error(msg) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Am.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var handleBlur = function handleBlur() {// Perform onBlur logic here
  };

  var handleChange = function handleChange() {// Perform onChange logic here
  };

  var tl = new gsap__WEBPACK_IMPORTED_MODULE_11__/* .TimelineLite */ .Vq();

  var onSubmit = function onSubmit(e) {
    var api_services = _pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_7__/* .ApiServices.ADDSUBSCRIP */ .u.ADDSUBSCRIP;
    var formData = new FormData();
    formData.append('email', e === null || e === void 0 ? void 0 : e.email);

    if (e.email !== '') {
      dispatch((0,_pages_api_redux_home__WEBPACK_IMPORTED_MODULE_8__/* .postForm */ .Md)([api_services, formData])); // success('Successfully Submitted')

      reset();
    }
  };

  var count = 0;

  var onError = function onError(errors) {
    Object.values(errors).forEach(function (error) {
      count++;
    });

    if (count > 0) {
      react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Am.error('Fill out the correct inputs');
    }

    count = 0;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.error) !== '') {
      var _responseData$error;

      error(responseData === null || responseData === void 0 ? void 0 : (_responseData$error = responseData.error) === null || _responseData$error === void 0 ? void 0 : _responseData$error.message);
    }

    if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.success) !== '') {
      success(responseData === null || responseData === void 0 ? void 0 : responseData.success);
    }
  }, [responseData]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledSubscribe, {
    className: "subscribe   pt-160  pb-160 ",
    children: [(section_image === null || section_image === void 0 ? void 0 : (_section_image$list = section_image.list) === null || _section_image$list === void 0 ? void 0 : (_section_image$list$ = _section_image$list[0]) === null || _section_image$list$ === void 0 ? void 0 : _section_image$list$.full_path) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_ImgP__WEBPACK_IMPORTED_MODULE_6__/* .Img */ .E, {
        src: section_image === null || section_image === void 0 ? void 0 : (_section_image$list2 = section_image.list) === null || _section_image$list2 === void 0 ? void 0 : (_section_image$list2$ = _section_image$list2[0]) === null || _section_image$list2$ === void 0 ? void 0 : _section_image$list2$.full_path,
        alt: 'Shanta Securities Limited',
        layout: 'fill',
        objectFit: 'cover'
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          sm: 6,
          className: 'box',
          children: [no ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h2", {
            className: '',
            children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.short_desc)
          }) : (section_data === null || section_data === void 0 ? void 0 : section_data.short_desc) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h2", {
            className: '',
            children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.short_desc)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            className: "",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
              name: 'spam_protector',
              type: "hidden"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Group */ .Z.Group, {
              className: "form-group",
              controlId: "formBasicEmail",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Control */ .Z.Control, _objectSpread(_objectSpread({
                className: formState !== null && formState !== void 0 && (_formState$errors = formState.errors) !== null && _formState$errors !== void 0 && (_formState$errors$ema = _formState$errors.email) !== null && _formState$errors$ema !== void 0 && _formState$errors$ema.message ? 'has-error form-control-lg' : 'form-control-lg'
              }, register("email", {
                required: {
                  value: true,
                  message: 'Email is required'
                },
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Enter a valid Email'
                }
              })), {}, {
                type: "email",
                placeholder: "Your Email Address*"
              })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                className: "dc-btn-submit",
                onClick: handleSubmit(onSubmit, onError),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                  width: '100',
                  text: 'Subscribe',
                  color: '#3C3C3B',
                  hoverBackground: _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__/* .hover */ .Mr,
                  background: '#ED1B34'
                })
              })]
            })]
          })]
        })
      })
    })]
  });
};

var StyledSubscribe = styled_components__WEBPACK_IMPORTED_MODULE_17__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Newsletter__StyledSubscribe",
  componentId: "sc-1cbt91u-0"
})(["position:relative;overflow:hidden;.parent-div{padding-top:100%;position:absolute;left:0;right:0;bottom:0;top:0;}h2{font-family:", ";color:#ffffff;font-size:44px;font-weight:500;line-height:56px;margin:0 0 54px 0;}.form-group{position:relative;.form-control{height:45px;background-color:transparent;border-radius:40px;font-size:16px;font-weight:500;padding-left:30px;color:#FFFFFF;autocomplete:off;::placeholder{color:rgba(255,255,255,0.5);font-size:16px;font-weight:500;outline:none;border:none;}:focus{outline:none;outline-color:transparent;border-color:white;}}.dc-btn-submit{position:absolute;top:0;right:0;.dc-btn{height:45px;}a{display:flex;height:100%;width:100%;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;font-size:16px;font-weight:500;margin:0px;line-height:18px;color:#3C3C3B;text-transform:capitalize;border:none;background-color:#FFFFFF;letter-spacing:0px;position:relative;border-radius:30px;overflow:hidden;span{}}}}@media(max-width:767px){.form-group .form-control{padding-left:18px;color:rgb(255,255,255);padding-top:10px;}}input:-webkit-autofill{-webkit-text-fill-color:#fff !important;border:1px solid #FFFFFF;&:hover{border:1px solid #FFFFFF;}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__/* .title */ .TN);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Subscribe));

/***/ }),

/***/ 54652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ our_services; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./pages/api/network/ApiServices.js
var ApiServices = __webpack_require__(92495);
// EXTERNAL MODULE: ./pages/api/network/ApiParamKey.js
var ApiParamKey = __webpack_require__(11267);
// EXTERNAL MODULE: ./pages/api/store/index.js + 9 modules
var store = __webpack_require__(38584);
// EXTERNAL MODULE: ./pages/api/redux/services/index.js
var services = __webpack_require__(26407);
// EXTERNAL MODULE: ./components/innerbanner-v9.jsx
var innerbanner_v9 = __webpack_require__(8711);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/gsap/index.js
var gsap = __webpack_require__(62642);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(21608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/ImgP.jsx
var ImgP = __webpack_require__(98508);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
// EXTERNAL MODULE: ./styles/globalStyleVars.js
var globalStyleVars = __webpack_require__(68312);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/ZigZag.jsx










var SecuritySeal = function SecuritySeal(_ref) {
  var _data$data, _data$images, _data$images2, _data$data2, _data$data3, _data$data4, _data$data5, _data$images3, _data$images4, _data$images5, _data$images6, _data$images7, _data$images8, _data$data6, _data$data7, _data$data8, _data$data9;

  var reverse = _ref.reverse,
      data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSecurity, {
    id: data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.slug,
    className: "security-seal",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      fluid: true,
      className: " ".concat(reverse ? 'reverse pr-0' : 'pl-0'),
      children: reverse ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
        className: 'reverse-row',
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
          sm: {
            span: 7
          },
          className: "security-seal__text",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "heading",
            children: [(data === null || data === void 0 ? void 0 : data.images) && (data === null || data === void 0 ? void 0 : (_data$images = data.images) === null || _data$images === void 0 ? void 0 : _data$images.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$images2 = data.images) === null || _data$images2 === void 0 ? void 0 : _data$images2.map(function (e, index) {
              if ((e === null || e === void 0 ? void 0 : e.thumb) === 'on') {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "icon",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    src: e === null || e === void 0 ? void 0 : e.full_path,
                    alt: 'Shanta Securities Limited'
                  })
                });
              }
            })), (data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              children: data === null || data === void 0 ? void 0 : (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.title
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: (data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.description) && (0,lib/* default */.ZP)(data === null || data === void 0 ? void 0 : (_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : _data$data5.description)
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          sm: 5,
          className: "security-seal__img",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "security-seal__img__inner",
            children: (data === null || data === void 0 ? void 0 : data.images) && (data === null || data === void 0 ? void 0 : (_data$images3 = data.images) === null || _data$images3 === void 0 ? void 0 : _data$images3.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$images4 = data.images) === null || _data$images4 === void 0 ? void 0 : _data$images4.map(function (e, index) {
              if ((e === null || e === void 0 ? void 0 : e.banner) === 'on') {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(ImgP/* Img */.E, {
                  layout: 'responsive',
                  src: e === null || e === void 0 ? void 0 : e.full_path,
                  alt: 'Shanta Securities Limited'
                });
              }
            }))
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          sm: 5,
          className: "security-seal__img",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "security-seal__img__inner",
            children: (data === null || data === void 0 ? void 0 : data.images) && (data === null || data === void 0 ? void 0 : (_data$images5 = data.images) === null || _data$images5 === void 0 ? void 0 : _data$images5.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$images6 = data.images) === null || _data$images6 === void 0 ? void 0 : _data$images6.map(function (e, index) {
              if ((e === null || e === void 0 ? void 0 : e.banner) === 'on') {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(ImgP/* Img */.E, {
                  layout: 'responsive',
                  src: e === null || e === void 0 ? void 0 : e.full_path,
                  alt: 'Shanta Securities Limited'
                });
              }
            }))
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
          sm: {
            span: 7
          },
          className: "security-seal__text",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "heading",
            children: [(data === null || data === void 0 ? void 0 : data.images) && (data === null || data === void 0 ? void 0 : (_data$images7 = data.images) === null || _data$images7 === void 0 ? void 0 : _data$images7.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$images8 = data.images) === null || _data$images8 === void 0 ? void 0 : _data$images8.map(function (e, index) {
              if ((e === null || e === void 0 ? void 0 : e.thumb) === 'on') {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "icon",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", (0,defineProperty/* default */.Z)({
                    alt: 'Shanta Securities Limited',
                    src: e === null || e === void 0 ? void 0 : e.full_path
                  }, "alt", ""))
                });
              }
            })), (data === null || data === void 0 ? void 0 : (_data$data6 = data.data) === null || _data$data6 === void 0 ? void 0 : _data$data6.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              children: data === null || data === void 0 ? void 0 : (_data$data7 = data.data) === null || _data$data7 === void 0 ? void 0 : _data$data7.title
            })]
          }), (data === null || data === void 0 ? void 0 : (_data$data8 = data.data) === null || _data$data8 === void 0 ? void 0 : _data$data8.description) && (0,lib/* default */.ZP)(data === null || data === void 0 ? void 0 : (_data$data9 = data.data) === null || _data$data9 === void 0 ? void 0 : _data$data9.description)]
        })]
      })
    })
  });
};

var StyledSecurity = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ZigZag__StyledSecurity",
  componentId: "sc-1vvd2ld-0"
})(["background-color:#FFFFFF;padding:200px 0 0;&:last-child{padding-bottom:0;}.container-fluid{padding-right:", "px;&.reverse{padding-left:", "px;.security-seal__text{padding-left:0;padding-right:70px;}@media(max-width:992px){.reverse-row{flex-direction:column-reverse;}}}}.heading{display:flex;text-align:left;width:100%;align-items:center;justify-content:flex-start;margin-bottom:40px;.icon{img{width:40px;height:40px;margin-right:20px;display:inline-block;}}h4{font-size:32px;line-height:44px;margin-bottom:0;}}.security-seal__img{&__inner{padding-top:calc(600 / 530 * 100%);position:relative;}}.security-seal__text{padding-left:55px;h3{font-size:24px;font-weight:500;line-height:32px;color:#3C3C3B;margin-bottom:40px;}p{font-size:16px;line-height:22px;font-weight:500;color:#3C3C3B;}ul,ol{li{padding-left:20px;position:relative;&:after{height:10px;width:10px;background:", ";content:'';position:absolute;left:0;top:5px;border-radius:50%;}}}}@media(min-width:768px){.security-seal__text{display:flex;align-items:flex-start;flex-direction:column;justify-content:center;}}@media (max-width:991px){.container-fluid{padding-right:15px !important;padding-left:15px !important;}.security-seal__img{min-width:100%;padding:0;}.security-seal__text{min-width:100%;margin-top:60px;margin-left:0;padding-left:15px !important;padding-right:15px !important;}}@media (max-width:767px){padding:0px 0 120px !important;.dc-btn{margin-top:30px;}}"], function (props) {
  return props.offset ? props.offset : '90';
}, function (props) {
  return props.offset ? props.offset : '90';
}, globalStyleVars/* hover */.Mr);
/* harmony default export */ var ZigZag = (/*#__PURE__*/react.memo(SecuritySeal));
// EXTERNAL MODULE: ./components/home/Newsletter.jsx
var Newsletter = __webpack_require__(87820);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(22546);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(50067);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
// EXTERNAL MODULE: ./components/Img.jsx
var Img = __webpack_require__(68019);
// EXTERNAL MODULE: ./components/Title.jsx
var Title = __webpack_require__(93264);
// EXTERNAL MODULE: ./components/ButtonNormal.jsx
var ButtonNormal = __webpack_require__(77911);
;// CONCATENATED MODULE: ./components/BoxSlider.jsx



















var RandomSliderV1 = function RandomSliderV1(_ref) {
  var Data = _ref.Data,
      bg = _ref.bg;
  // SwiperCore.use([Autoplay]);
  var leftRef = (0,react.useRef)();
  var rightRef = (0,react.useRef)();
  var mLeftRef = (0,react.useRef)();
  var mRightRef = (0,react.useRef)();
  var containerRef = (0,react.useRef)();
  var sliderRef = (0,react.useRef)();

  var _useState = (0,react.useState)(90),
      offset = _useState[0],
      setOffset = _useState[1];

  var _useState2 = (0,react.useState)(0),
      theWidth = _useState2[0],
      SetTheWidth = _useState2[1];

  var _useState3 = (0,react.useState)(1),
      activeNumber = _useState3[0],
      setActiveNumber = _useState3[1];

  var _useState4 = (0,react.useState)(1),
      totalNumber = _useState4[0],
      setTotalNumber = _useState4[1];

  var dispath = (0,es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    mLeftRef.current.addEventListener('click', function () {
      if (document.querySelector('.swiper-button-prev')) {
        document.querySelector('.swiper-button-prev').click();
      }
    });
    mRightRef.current.addEventListener('click', function () {
      if (document.querySelector('.swiper-button-next')) {
        document.querySelector('.swiper-button-next').click();
      }
    });
    setOffset(document.querySelector(' .container').offsetLeft);
  }, []);
  (0,react.useEffect)(function () {
    var _containerRef$current, _document$querySelect, _document$querySelect2;

    setOffset((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetLeft);
    window.addEventListener('resize', function () {
      var _containerRef$current2;

      setOffset((_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.offsetLeft);
      SetTheWidth(window.innerWidth);
    }); // slider number

    var getActiveItem = (_document$querySelect = document.querySelector('.swiper-pagination-current')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerHTML;
    var getTotalItem = (_document$querySelect2 = document.querySelector('.swiper-pagination-total')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.innerHTML;
    setActiveNumber(getActiveItem);
    setTotalNumber(getTotalItem);
  }, [Data]);
  (0,react.useEffect)(function () {// document.querySelector('.swiper-container').style.paddingLeft = offset + 'px'
  }, [offset, sliderRef]);
  (0,react.useEffect)(function () {
    if (sliderRef.current) {
      var swiperInstance = sliderRef.current.swiper;

      if (swiperInstance) {
        setTotalNumber(swiperInstance.slides.length);
      }
    }
  }, [Data]);

  var _useState5 = (0,react.useState)(0),
      swiperIndex = _useState5[0],
      setSwiperIndex = _useState5[1];

  var handleSlideChange = function handleSlideChange(swiper) {
    setSwiperIndex(swiper.realIndex);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledBlog, {
    bg: bg,
    offset: offset,
    className: "blog-slider box-slider pt-200 pb-200 ",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      ref: containerRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          sm: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "blog-button",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "left",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title["default"], {
                noanim: true,
                margin: '0 0 0 0',
                text: 'Research <span>Center</span>'
              })
            }), (Data === null || Data === void 0 ? void 0 : Data.length) > 4 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "d-flex",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "slider-nav",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "hover",
                    id: 'our-services-prev',
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BsChevronLeft */.pjk, {})
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "hover",
                    id: 'our-services-next',
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BsChevronRight */.fmn, {})
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNormal["default"], {
                margin: '0 0 0 40px',
                icon: true,
                src: '/research',
                color: '#3C3C3B',
                hoverColor: '#3C3C3B',
                text: 'View All'
              })]
            })]
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: " fade-up blog-slider__slider-wrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "blog-slider__slider-wrap__inner",
        children: (Data === null || Data === void 0 ? void 0 : Data.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 30,
          speed: "1500",
          keyboardControl: true,
          modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Pagination */.tl, swiper_esm/* Navigation */.W_, swiper_esm/* Mousewheel */.Gk],
          navigation: {
            prevEl: '#our-services-prev',
            nextEl: '#our-services-next'
          },
          onSlideChange: handleSlideChange,
          pagination: {
            type: 'fraction'
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 30
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            }
          },
          ref: sliderRef,
          className: "mySwiper",
          children: Data && (Data === null || Data === void 0 ? void 0 : Data.length) > 0 && (Data === null || Data === void 0 ? void 0 : Data.map(function (e, index) {
            var _e$file, _e$file$list, _e$file$list$;

            var dateString = e !== null && e !== void 0 && e.date ? e === null || e === void 0 ? void 0 : e.date : e === null || e === void 0 ? void 0 : e.created_at;
            var date = new Date(dateString);
            var options1 = {
              day: 'numeric'
            };
            var options2 = {
              month: 'long',
              year: 'numeric'
            };
            var formattedDate1 = date.toLocaleDateString('en-US', options1);
            var formattedDate2 = date.toLocaleDateString('en-US', options2);
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: 'blog-single-single-wrp',
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "blog-single ",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "blog-single__inner",
                    children: [(e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: e === null || e === void 0 ? void 0 : e.attachment,
                      target: '_blank'
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                      alt: e === null || e === void 0 ? void 0 : e.subtitle,
                      src: e !== null && e !== void 0 && e.thumb ? e === null || e === void 0 ? void 0 : e.thumb : '/images/static/report.jpg',
                      objectFit: 'cover',
                      layout: 'fill'
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "blog-single__inner__content",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "blog-single__inner__content__top",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "hover-content",
                          children: [(e === null || e === void 0 ? void 0 : e.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.subtitle)
                          }), (e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            className: 'link-dc',
                            href: e === null || e === void 0 ? void 0 : (_e$file = e.file) === null || _e$file === void 0 ? void 0 : (_e$file$list = _e$file.list) === null || _e$file$list === void 0 ? void 0 : (_e$file$list$ = _e$file$list[0]) === null || _e$file$list$ === void 0 ? void 0 : _e$file$list$.full_path,
                            target: '_blank',
                            children: "Read More"
                          })]
                        }), (e === null || e === void 0 ? void 0 : e.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                          children: e === null || e === void 0 ? void 0 : e.title
                        })]
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "blog-single__inner__content__bottom",
                        children: [formattedDate1 && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                          children: formattedDate1
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                          children: [formattedDate2 && (0,lib/* default */.ZP)(formattedDate2), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: (e === null || e === void 0 ? void 0 : e.type) === '1' ? 'Economy' :  false || (e === null || e === void 0 ? void 0 : e.type) === '2' ? 'Market Review' :  false || (e === null || e === void 0 ? void 0 : e.type) === '3' ? 'Strategy Report' :  false || (e === null || e === void 0 ? void 0 : e.type) === '4' ? 'Comapny Review' :  false || (e === null || e === void 0 ? void 0 : e.type) === '5' ? 'Dashboard Review' :  false || (e === null || e === void 0 ? void 0 : e.type) === '6' ? 'Newsflash' : ''
                          })]
                        })]
                      })]
                    })]
                  })
                })
              })
            }, index);
          }))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "slider-nav-mobile",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "hover",
            ref: mLeftRef,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BsChevronLeft */.pjk, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "hover",
            ref: mRightRef,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BsChevronRight */.fmn, {})
          })]
        })
      })]
    })]
  });
};

var StyledBlog = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "BoxSlider__StyledBlog",
  componentId: "sc-1yhw5oq-0"
})(["background:", ";.swiper-button-disabled{opacity:0.5 !important;}.image-wrapper{position:absolute;left:0;right:0;bottom:0;height:50%;}.blog-button{display:flex;justify-content:space-between;margin-bottom:85px;align-items:center;.left,.d-flex{height:100%;}.slider-nav{ul{display:flex;}li{height:40px;width:40px;background-color:black;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;&:nth-of-type(1){margin-right:20px;}svg{color:#ffffff;z-index:2;}}}}.swiper-button-next,.swiper-button-prev{position:absolute;height:40px;width:40px;top:0;bottom:0;margin:auto;z-index:99;background-color:red;}.swiper-button-next,.swiper-button-prev,.swiper-pagination{opacity:0;visibility:hidden;}.swiper-initialized{margin-left:", "px;padding-right:8%;}.slider-nav-mobile{display:none;}.blog-slider{&__slider-wrap{&__inner{.blog-single{&__inner{padding-top:115%;}}}}}.blog-single-single-wrp{}.load{.dc-btn{display:flex;align-items:center;justify-content:center;margin-top:50px;}}.blog-slider{&__slider-wrap{&__inner{.blog-single{&__inner{padding-top:115%;}}}}}.single-expert-item{&:hover{.global-image{img{}}}}.blog-single__inner{padding-top:calc(460 / 370 * 100%);position:relative;.global-image{img{transform:scale(1.01);}}a{position:absolute;height:100%;width:100%;left:0;top:0;z-index:3;}&__content{&:after{content:'';height:100%;width:100%;background-color:#3C3C3B;top:0;left:0;right:0;position:absolute;transition:height 1s cubic-bezier(.25,.74,.22,.99);}&__top{.hover-content{position:absolute;left:40px;top:40px;right:40px;transition:all 1s cubic-bezier(.25,.74,.22,.99);transform:translateY(-30px);opacity:0;.link-dc{font-size:16px;line-height:24px;color:#FFFFFF;font-family:'Avenir Heavy';width:auto !important;height:auto !important;position:relative !important;margin-top:5px;opacity:0;display:inline-block;&:before{background:#fff;transition:all 1s cubic-bezier(.25,.74,.22,.99) 0s;content:\"\";position:absolute;left:0px;bottom:0px;height:1px;width:100%;}&:hover{&:before{height:4px;}}}p{font-size:16px;font-weight:500;line-height:24px;color:#ffffff;z-index:2;margin:0;opacity:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}h2{position:absolute;top:40px;left:40px;right:40px;z-index:2;font-size:20px;font-weight:500;font-family:", ";line-height:28px;color:#FFFFFF;margin:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}&__bottom{position:absolute;margin:0;left:40px;right:40px;bottom:24px;display:flex;justify-content:space-between;padding-top:20px;z-index:2;h4{font-size:60px;color:#FFFFFF;font-family:'Avenir Book';line-height:60px;transition:color 1s cubic-bezier(.25,.74,.22,.99);}p{font-size:16px;color:#FFFFFF;text-align:right;font-weight:500;line-height:24px;transition:color 1s cubic-bezier(.25,.74,.22,.99);span{display:block;color:#FFFFFF;}}}}&:hover{.blog-single__inner__content:after{height:0;}.blog-single__inner__content__top{h2{opacity:0;transform:translateY(-20px);}.link-dc{transform:none;opacity:1;&:before{}}.hover-content{transform:none;opacity:1;}p{transform:none;opacity:1;}}.blog-single__inner__content__bottom{border-color:#FFF;h4{color:#ffffff;}p{color:#ffffff;span{color:#ffffff;}}}}}@media (max-width:767px){padding-bottom:120px !important;.mobile{display:block;}.desktop{display:none !important;}.blog-single__inner__content__top{p,h2{left:30px;right:30px;top:30px;}}.blog-single__inner__content__bottom h4,.blog-single__inner__content__bottom p{left:30px;right:30px;top:30px;}.swiper-initialized{margin-left:15px;padding-right:15px;}.blog-slider{&__slider-wrap{.slider-nav-mobile{margin-top:40px;ul{display:flex;}li{height:50px;width:50px;background-color:#000;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;&:nth-of-type(1){margin-right:20px;}svg{color:#ffffff;z-index:2;}}}}}.blog-button{margin-bottom:40px;flex-direction:column;align-items:flex-start;.slider-nav{}}.slider-nav-mobile{display:none;}}"], function (props) {
  return props.bg ? props.bg : '#F2F2F2';
}, function (props) {
  return props.offset + 15;
}, globalStyleVars/* title */.TN);
/* harmony default export */ var BoxSlider = (/*#__PURE__*/react.memo(RandomSliderV1));
// EXTERNAL MODULE: ./components/CTA-v3.jsx
var CTA_v3 = __webpack_require__(69589);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 166 modules
var motion = __webpack_require__(11125);
// EXTERNAL MODULE: ./components/PageAnimation.js
var PageAnimation = __webpack_require__(44937);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(56546);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollToPlugin.js
var ScrollToPlugin = __webpack_require__(39664);
;// CONCATENATED MODULE: ./pages/our-services/index.jsx


























var Services = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6984).then(__webpack_require__.bind(__webpack_require__, 46984));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46984)];
    }
  }
});
gsap/* default.registerPlugin */.ZP.registerPlugin(ScrollTrigger.ScrollTrigger, ScrollToPlugin.ScrollToPlugin);

var Career = function Career(_ref) {
  var _getPost$posts, _getPost$posts$data, _getPost$posts2, _getPost$posts2$data, _getPost$posts2$data$, _getPost$posts3, _getPost$posts3$data, _getPost$posts3$data$, _getPost$posts4, _getPost$posts4$data, _getPost$posts4$data$, _getPost$posts5, _getPost$posts5$data, _getPost$posts5$data$, _getPost$posts6, _getPost$posts6$data, _getPost$posts6$data$, _banner$section_data, _banner$images, _banner$images$list, _banner$images$list$, _services_l$posts, _services_l$posts2, _services_l$posts2$li, _services_l$posts3, _services_l$posts3$li, _getPost$detail;

  var offset = _ref.offset,
      winWidth = _ref.winWidth;
  var getPost = (0,es/* useSelector */.v9)(function (state) {
    return state.servicesReducer;
  });
  var router = (0,next_router.useRouter)();
  var page_data = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts = getPost.posts) === null || _getPost$posts === void 0 ? void 0 : (_getPost$posts$data = _getPost$posts.data) === null || _getPost$posts$data === void 0 ? void 0 : _getPost$posts$data.page_data;
  var banner = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts2 = getPost.posts) === null || _getPost$posts2 === void 0 ? void 0 : (_getPost$posts2$data = _getPost$posts2.data) === null || _getPost$posts2$data === void 0 ? void 0 : (_getPost$posts2$data$ = _getPost$posts2$data.sections) === null || _getPost$posts2$data$ === void 0 ? void 0 : _getPost$posts2$data$.find(function (f) {
    var _f$section_data;

    return (f === null || f === void 0 ? void 0 : (_f$section_data = f.section_data) === null || _f$section_data === void 0 ? void 0 : _f$section_data.slug) === 'banner-services';
  });
  var services_list = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts3 = getPost.posts) === null || _getPost$posts3 === void 0 ? void 0 : (_getPost$posts3$data = _getPost$posts3.data) === null || _getPost$posts3$data === void 0 ? void 0 : (_getPost$posts3$data$ = _getPost$posts3$data.sections) === null || _getPost$posts3$data$ === void 0 ? void 0 : _getPost$posts3$data$.find(function (f) {
    var _f$section_data2;

    return (f === null || f === void 0 ? void 0 : (_f$section_data2 = f.section_data) === null || _f$section_data2 === void 0 ? void 0 : _f$section_data2.slug) === 'services-overview';
  });
  var services_l = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts4 = getPost.posts) === null || _getPost$posts4 === void 0 ? void 0 : (_getPost$posts4$data = _getPost$posts4.data) === null || _getPost$posts4$data === void 0 ? void 0 : (_getPost$posts4$data$ = _getPost$posts4$data.sections) === null || _getPost$posts4$data$ === void 0 ? void 0 : _getPost$posts4$data$.find(function (f) {
    var _f$section_data3;

    return (f === null || f === void 0 ? void 0 : (_f$section_data3 = f.section_data) === null || _f$section_data3 === void 0 ? void 0 : _f$section_data3.slug) === 'services-list';
  });
  var newsletter = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts5 = getPost.posts) === null || _getPost$posts5 === void 0 ? void 0 : (_getPost$posts5$data = _getPost$posts5.data) === null || _getPost$posts5$data === void 0 ? void 0 : (_getPost$posts5$data$ = _getPost$posts5$data.sections) === null || _getPost$posts5$data$ === void 0 ? void 0 : _getPost$posts5$data$.find(function (f) {
    var _f$section_data4;

    return (f === null || f === void 0 ? void 0 : (_f$section_data4 = f.section_data) === null || _f$section_data4 === void 0 ? void 0 : _f$section_data4.slug) === 'services-newsletter';
  });
  var services_cta = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts6 = getPost.posts) === null || _getPost$posts6 === void 0 ? void 0 : (_getPost$posts6$data = _getPost$posts6.data) === null || _getPost$posts6$data === void 0 ? void 0 : (_getPost$posts6$data$ = _getPost$posts6$data.sections) === null || _getPost$posts6$data$ === void 0 ? void 0 : _getPost$posts6$data$.find(function (f) {
    var _f$section_data5;

    return (f === null || f === void 0 ? void 0 : (_f$section_data5 = f.section_data) === null || _f$section_data5 === void 0 ? void 0 : _f$section_data5.slug) === 'services-cta';
  }); // useEffect(() => {
  //     // Check if running in a browser environment
  //     if (typeof window !== 'undefined') {
  //         const urlFragment = window.location.hash;
  //         const urlhas = urlFragment ? `${urlFragment}` : null; // Prepend '#' if fragment
  //
  //         console.log(urlhas, 'ok')
  //         if (urlhas) {
  //             setTimeout(() => {
  //                 const targetElement = urlhas;
  //                 if (targetElement) {
  //                     document.body.style.overflow = 'auto';
  //                     const html = document.querySelector('html');
  //                     html.style.overflow = 'auto';
  //
  //                     gsap.to(window, {
  //                         duration: 1,
  //                         scrollTo: {y: targetElement.offsetTop}
  //                     });
  //                 }
  //             }, 600);
  //         }
  //     }
  // }, []);

  (0,react.useEffect)(function () {
    // Check if running in a browser environment
    if (true) {
      var urlFragment = window.location.hash;
      var urlhas = urlFragment ? urlFragment.slice(1) : null; // Remove the '#' from the fragment

      if (urlhas) {
        setTimeout(function () {
          var targetElement = document.getElementById(urlhas) || document.querySelector(urlhas);

          if (targetElement) {
            document.body.style.overflow = 'auto';
            var html = document.querySelector('html');
            html.style.overflow = 'auto'; // Use targetElement.offsetTop instead of passing the element itself

            gsap/* default.to */.ZP.to(window, {
              duration: 1,
              scrollTo: {
                y: targetElement.offsetTop
              } // Correct usage of scrollTo

            });
          }
        }, 600);
      }
    }
  }, []); // No dependencies, run once on mount
  // useEffect(() => {
  //     let split = gsap.utils.toArray(".split-up");
  //     gsap.registerPlugin(CSSPlugin);
  //
  //     if (window.innerWidth > 767) {
  //         gsap.utils.toArray('.split-up').forEach((item, i) => {
  //             const parentSplit = new SplitText(item, {
  //                 linesClass: "split-parent",
  //                 type: "lines",
  //             });
  //             const childSplit = new SplitText(item, {
  //                 type: "lines",
  //                 linesClass: "split-child"
  //             });
  //
  //             gsap.from(parentSplit.lines, {
  //                 duration: 1,
  //                 yPercent: 150,
  //                 ease: 'power4.out',
  //                 stagger: .08,
  //                 scrollTrigger: {
  //                     trigger: item,
  //                     toggleActions: "restart none none reset",
  //                     start: "top 98%",
  //                 }
  //             });
  //         });
  //     }
  // }, [getPost]);

  var location = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    // Use GSAP to animate opacity from 0 to 1
    gsap/* default.to */.ZP.to('.hide', {
      alpha: 1,
      visibility: 'visible',
      display: 'block',
      duration: 0.5,
      delay: 1
    });
  }, [location.pathname]); // Run this effect only once when the component mounts

  var currentUrl = router && router.asPath;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "".concat(page_data !== null && page_data !== void 0 && page_data.title ? (page_data === null || page_data === void 0 ? void 0 : page_data.title) + ' | Shanta Securities Limited' : 'Shanta Securities Limited'),
      description: page_data === null || page_data === void 0 ? void 0 : page_data.meta_description,
      canonical: "https://www.shantasecurities.com" + currentUrl,
      openGraph: {
        type: 'website',
        url: "https://www.shantasecurities.com" + currentUrl,
        title: page_data === null || page_data === void 0 ? void 0 : page_data.og_title,
        description: page_data === null || page_data === void 0 ? void 0 : page_data.og_description,
        images: [{
          url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }, {
          url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledComponent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(innerbanner_v9/* default */.Z, {
        title: page_data === null || page_data === void 0 ? void 0 : page_data.title,
        text: banner === null || banner === void 0 ? void 0 : (_banner$section_data = banner.section_data) === null || _banner$section_data === void 0 ? void 0 : _banner$section_data.short_desc,
        src: banner === null || banner === void 0 ? void 0 : (_banner$images = banner.images) === null || _banner$images === void 0 ? void 0 : (_banner$images$list = _banner$images.list) === null || _banner$images$list === void 0 ? void 0 : (_banner$images$list$ = _banner$images$list[0]) === null || _banner$images$list$ === void 0 ? void 0 : _banner$images$list$.full_path
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        exit: "exit",
        animate: "anim",
        initial: "init",
        className: "page-loader pagetransition-loader",
        variants: PageAnimation/* PageAnimation */.t
      }, '181'), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "service service_page",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Services, {
          id: 'services',
          services_data: services_list
        })
      }), (services_l === null || services_l === void 0 ? void 0 : (_services_l$posts = services_l.posts) === null || _services_l$posts === void 0 ? void 0 : _services_l$posts.list) && (services_l === null || services_l === void 0 ? void 0 : (_services_l$posts2 = services_l.posts) === null || _services_l$posts2 === void 0 ? void 0 : (_services_l$posts2$li = _services_l$posts2.list) === null || _services_l$posts2$li === void 0 ? void 0 : _services_l$posts2$li.length) > 0 && (services_l === null || services_l === void 0 ? void 0 : (_services_l$posts3 = services_l.posts) === null || _services_l$posts3 === void 0 ? void 0 : (_services_l$posts3$li = _services_l$posts3.list) === null || _services_l$posts3$li === void 0 ? void 0 : _services_l$posts3$li.map(function (e, index) {
        return index % 2 === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(ZigZag, {
          index: index,
          data: e,
          offset: offset
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ZigZag, {
          index: index,
          data: e,
          reverse: true,
          offset: offset
        });
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter["default"], {
        no: true,
        data: newsletter
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " service_blog_slider",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BoxSlider, {
          Data: getPost === null || getPost === void 0 ? void 0 : (_getPost$detail = getPost.detail) === null || _getPost$detail === void 0 ? void 0 : _getPost$detail.data
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTA_v3["default"], {
        data: services_cta,
        winWidth: winWidth,
        offset: offset
      })]
    })]
  });
};

var StyledComponent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "our-services__StyledComponent",
  componentId: "sc-9v8iie-0"
})([".home-blue-bg-info{padding-top:160px;}@media (max-width:767px){.service_page{padding-bottom:120px;}}.subscribe{margin-top:200px;}.blog-slider{}"]);
Career.getInitialProps = store/* wrapper.getInitialPageProps */.YS.getInitialPageProps(function (store) {
  return /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var fetchData;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetchData = /*#__PURE__*/function () {
              var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                var _param;

                var api_url, api_url_reserch, param;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        api_url = ApiServices/* ApiServices.SECTIONS */.u.SECTIONS;
                        api_url_reserch = ApiServices/* ApiServices.SERVICERESEARCH */.u.SERVICERESEARCH;
                        param = (_param = {}, (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, 'slug'), (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.VALUE */.j.VALUE, 'services'), (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.GET_SECTION */.j.GET_SECTION, 'yes'), (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.IMAGE */.j.IMAGE, 'yes'), (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.POST */.j.POST, 'yes'), (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.GALLERY */.j.GALLERY, 'yes'), _param);
                        _context.prev = 3;
                        _context.next = 6;
                        return Promise.all([store.dispatch((0,services/* fetchPosts */.T6)([api_url, param])), store.dispatch((0,services/* fetchPostDetail */.QL)([api_url_reserch]))]);

                      case 6:
                        _context.next = 11;
                        break;

                      case 8:
                        _context.prev = 8;
                        _context.t0 = _context["catch"](3);
                        // Handle errors gracefully
                        console.error('Error fetching data:', _context.t0); // Optionally, you can set a flag in the Redux store to indicate an error
                        // This flag can be used to display an error message in the UI
                        // Example: store.dispatch(setErrorFlag(true));

                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[3, 8]]);
              }));

              return function fetchData() {
                return _ref3.apply(this, arguments);
              };
            }();

            _context2.next = 3;
            return fetchData();

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
});
/* harmony default export */ var our_services = (Career);

/***/ }),

/***/ 10781:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-services",
      function () {
        return __webpack_require__(54652);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 13390:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,7724,7006,1118,1125,8800,9774,2888,179], function() { return __webpack_exec__(10781); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);